import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class NavbarMenu extends Component {

  _ACTIVE_CLASS_NAME = 'is-active';

  configure() {
    return super.configure();
  }

  initialize() {
    this.itemsHasSubmenu = document.querySelectorAll('.navbar-item[data-tab-id]');
    this.autoScroll();
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    for (let i = 0; i < this.itemsHasSubmenu.length; i++ ) {
      // On clicks show submenus
      this.itemsHasSubmenu[i].addEventListener('click', (event) => {
        return this.onClick(event);
      });
    }

  }

  /**
   * Shows submenu on click
   *
   * @param event
   */
  onClick(event) {
    // We lose reference of this when filtering the nav items
    let self = event.currentTarget;

    // Select the relevant submenu, by the data-id attribute
    let submenu = document.getElementById(self.dataset.tabId);

    // Probably best to prevent clicks through
    event.preventDefault();

    // Referring to the submenu parentNode
    // find all elements that aren't the submenu and remove active class
    let otherSubmenu = Array.prototype.filter.call(
      submenu.parentNode.children,
      (child) => {
        if (child !== submenu) {
          this.removeChildClass(child);
        }
      });

    // Referring to the the nav item parentNode
    // find all elements that aren't the submenu and remove active class
    let otherItem = Array.prototype.filter.call(
      self.parentNode.parentNode.children,
      (child) => {

        Array.prototype.filter.call(
          child.children,
          (subChild) => {

            if (subChild !== self) {
              this.removeChildClass(subChild);
            }
          });
      });

    self.classList.toggle(this._ACTIVE_CLASS_NAME);
    submenu.classList.toggle(this._ACTIVE_CLASS_NAME);
  }

  removeChildClass(element) {
    // Check if it exists, then remove
    if (element.classList.contains(this._ACTIVE_CLASS_NAME)) {
      element.classList.remove(this._ACTIVE_CLASS_NAME);
    }
  }

  autoScroll() {

    // Auto scrolling navbar
    let scroll = document.querySelectorAll('.navbar .scroll .is-active');

    for (let i = 0; i < scroll.length; i++ ) {
      scroll[i].parentNode.scrollLeft = scroll[i].offsetLeft;
    }

    // Auto scrolling tabs (submenu)
    scroll = document.querySelectorAll('.tabs.is-scrollable .is-active');
    for (let i = 0; i < scroll.length; i++ ) {
      scroll[i].parentNode.parentNode.scrollLeft = scroll[i].offsetLeft;
    }

  }

}